import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material";
import { SignatureDefaultDialogProvider } from "pages/signatures/providers/signature-defaults/SignatureDefaultDialogProvider";
import React from "react";
import { colors, gaps } from "theme/defaultStyle";
// import { useSignatureDefaults } from "utils/context/SignatureDefaultsContext";
// import { useSignatures } from "utils/context/SignaturesContext";
// import SignatureDefaultDialog from "../default-dialog";
import AddDefaultLink from "./AddDefaultLink";
import SignatureDefaultsTable from "./SignatureDefaultsTable";
// import { useGlobalAccess } from "utils/context/GlobalAccessContext";
import CollapsableFormSection from "controls/global/collapsable-form-section/CollapsableFormSection";

type Props = {
  titleRef?: React.MutableRefObject<any>;
};

const SUB_HEADING_TEXT = `Add a new default signature or view/edit an existing default signature. Defaults designated as “Agency-Wide” apply to all users who have access to the assigned agencies.`;

const SectionContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: gaps.large1,
});

const SignatureDefaults = ({ titleRef }: Props) => {
  // const [, { getDefaults }] = useSignatureDefaults();
  // const [{ signatureModified }] = useSignatures();
  // const [{ selectedAgency: globalAccessAgency }] = useGlobalAccess();
  // const isFirstRender = useRef(true);

  // useEffect(() => {
  //   // skip 1st run
  //   if (isFirstRender.current) {
  //     isFirstRender.current = false;
  //     return;
  //   }
  //   getDefaults(globalAccessAgency[0]?.CompanyID);
  // }, [getDefaults, signatureModified, globalAccessAgency]);

  return (
    <SectionContainer>
      <SignatureDefaultDialogProvider>
        <CollapsableFormSection index={0} title="Default Signatures">
          <Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={3}
              ml={1.5}
            >
              <Typography className="subheading" sx={{ color: colors.blue01 }}>
                {SUB_HEADING_TEXT}
              </Typography>
            </Box>
            <SignatureDefaultsTable />
            <Box mt={3}>
              <AddDefaultLink />
            </Box>
          </Box>
        </CollapsableFormSection>
        {/* <SignatureDefaultDialog /> */}
      </SignatureDefaultDialogProvider>
    </SectionContainer>
  );
};

export default SignatureDefaults;
